export { default as PurchaseCarStep1 } from './step1.svg';
export { default as PurchaseCarStep2 } from './step2.svg';
export { default as PurchaseCarStep3 } from './step3.svg';
